import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-article]')) return;

  dataLayerArticleHeader();
}

function dataLayerArticleHeader() {
  // Chips
  $$('[data-au-article-chip]').forEach((chip) => {
    chip.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('section').querySelector('[data-au-title]').innerText;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_tag_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id,
      });
    });
  });

  // Download
  $$('[data-au-inline-media-download]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('[data-au-article]').querySelector('[data-au-title]').innerText;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickDescarga',
        item_id,
      });
    });
  });
}

export default { init };
